
const styles = theme => ({
    root: {
        flexGrow: 1,
        minHeight: "100vh",
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary
    },
    grow: {
        flexGrow: 1,
    },
    main: {
        backgroundColor: theme.palette.background.default,
        zIndex: theme.zIndex.drawer + 1,
        minHeight: "100vh"
    }
});

export default styles;
